import { type JSX, For } from 'solid-js';
import { ResultHeader, type DropdownOption } from './ResultHeader';
import { ResultRow, ResultRowProps } from './ResultRow';
import {
  MeasurementInfoButtonConfig,
  SlopeFormat,
} from '@trimble/web3d-providers';

interface MeasurementPropertyProps {
  icon: string;
  title: string;
  resultRows: ResultRowProps[];
  testId?: string;
  dropdownOptions?: DropdownOption[];
  selectedDropdownValue?: SlopeFormat;
  onDropdownChange?(value: SlopeFormat): void;
  infoButtonConfig?: MeasurementInfoButtonConfig;
  disableDropdown?: boolean;
  disabledReason?: string;
}

export const MeasurementProperty = (
  props: MeasurementPropertyProps
): JSX.Element => {
  return (
    <div class="flex flex-col gap-1" data-testid={props.testId}>
      <ResultHeader
        icon={props.icon}
        title={props.title}
        dropdownOptions={props.dropdownOptions}
        selectedDropdownValue={props.selectedDropdownValue}
        onDropdownChange={props.onDropdownChange}
        infoButtonConfig={props.infoButtonConfig}
        disableDropdown={props.disableDropdown}
        disabledReason={props.disabledReason}
      />
      <For each={props.resultRows}>
        {(row, _) => <ResultRow cells={row.cells} testId={row.testId} />}
      </For>
    </div>
  );
};
